import { gql } from '@apollo/client'
import React from 'react'

import { formsClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { useModalData } from '../../../../components/modals/ModalsContext'

const Context = React.createContext([])
const { Provider } = Context
export const useFormState = () => React.useContext(Context)
export const useForm = () => useFormState()?.form

const QUERY = gql`
  query Form($id: ID) {
    form(id: $id) {
      id
      name
      description
      redirectToExecution
      access
      repliesCount
      shareCode
      placeType
      themeColor
      logoId
      logo {
        id
        src
      }
      configuration
      checklistId
      checklist {
        id
        name
      }
    }
  }
`

const FormLoader = ({ children }) => {
  const id = useModalData()
  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: formsClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default FormLoader
